import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AppState} from '../reducers';
import * as YearsActions from '../actions/YearsActions';
import {IYear} from '../models/IYearModel';
import {getYears} from '../reducers/Years.Reducer';
import {Observable} from 'rxjs/index';

import {IStates} from '../models/IStatesModel';
import {getStates} from '../reducers/States.Reducer';
import * as FormFilterActions from '../actions/FormFilterActions';
import * as StatesActions from '../actions/StatesActions';
import {ICountyModel} from '../models/ICountyModel';
import {getCounties} from '../reducers/Counties.Reducer';
import * as CountyActions from '../actions/CountyActions';
import * as CommodityActions from '../actions/CommodityActions';
import {ICommodities} from '../models/ICommodityModel';
import {getCommodities} from '../reducers/CommodityReducer';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-form-filter',
  templateUrl: './form-filter.component.html',
  styleUrls: ['./form-filter.component.scss'],
  providers: [FormBuilder]
})
export class FormFilterComponent implements OnInit, AfterViewInit, OnDestroy {
  public form: FormGroup;
  public years$: Observable<Array<IYear>>;
  public states$: Observable<Array<IStates>>;
  public counties$: Observable<Array<ICountyModel>>;
  public commodities$: Observable<Array<ICommodities>>;
  public uniqueCommodities: Array<ICommodities>;
  private yearsSubscription;
  private stateSubscription;
  private countiesSubscription;
  private commoditiesSubscription;
  private stateId = null;
  private commodityCode = null;
  private year = null;


  constructor(@Inject(FormBuilder) fb: FormBuilder, public store: Store<AppState>, private activatedRoute: ActivatedRoute) {
    this.years$ = this.store.select(getYears);
    this.states$ = this.store.select(getStates);
    this.counties$ = this.store.select(getCounties);
    this.commodities$ = this.store.select(getCommodities);

    this.form = fb.group({
      year: '',
      state: {},
      county: {},
      commoditySelect: {}
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (Object.keys(params).length > 0) {
        this.stateId = params['stateId'];
        this.commodityCode = params['commodityCode'];
        this.year = params['year'];
      }
    });
    this.yearsSubscription = this.years$.subscribe((years) => {
      if (years.length > 0 && this.form.controls['year'].pristine) {
        this.form.controls['commoditySelect'].setValue('');
        if (!this.year) {
          const currentYear = new Date().getFullYear();
          const foundYear = years.find((y) => y.year === currentYear);
          this.store.dispatch(StatesActions.retrieveStatesAction({year: foundYear.year}));
          this.form.controls['year'].setValue(foundYear);
        } else {
          const year: IYear = {year: parseInt(this.year, 10)};
          this.store.dispatch(FormFilterActions.UpdateYearAction({year: year}));
          this.store.dispatch(StatesActions.retrieveStatesAction({year: year.year}));
          const foundYear = years.find((y) => y.year === parseInt(this.year, 10));
          this.form.controls['year'].setValue(foundYear);
        }
      }
    });

    this.store.dispatch(YearsActions.retrieveYearsAction());


    this.stateSubscription = this.states$.subscribe((states) => {
      if (states.length > 1 && this.form.controls['state'].pristine) {
        const initialState = () => this.stateId != null ? states.find(state =>
          state.federalStateNumber === this.stateId) : states.find(state => state.id === 15);
        this.form.controls['state'].setValue(initialState());
      }
    });

    this.countiesSubscription = this.counties$.subscribe((counties) => {
      if (counties.length > 1 && this.form.controls['county'].pristine) {
        const initialCounty = () => counties.find(county => county.Id === 153);
        this.form.controls['county'].setValue(initialCounty());
      }
    });

    this.commoditiesSubscription = this.commodities$.subscribe((commodities) => {
      const uniqueCommodities = commodities.filter((c, i, arr) =>
        arr.findIndex(a => a.CommodityCode === c.CommodityCode) === i);
      this.uniqueCommodities = uniqueCommodities;
      if (uniqueCommodities.length > 0 && this.form.controls['commoditySelect'].pristine && this.commodityCode != null) {
        const foundCommodity = uniqueCommodities.find((uc) => uc.CommodityCode === this.commodityCode);
        this.form.get('commoditySelect').setValue(foundCommodity);
      }
    });

    this.form.get('year').valueChanges.subscribe((val: IYear) => {
      this.store.dispatch(FormFilterActions.UpdateYearAction({year: val}));
      if (this.form.get('state').value != null) {
        this.store.dispatch(CommodityActions.RetrieveCommoditiesAction({
          year: val.year,
          stateCode: this.form.get('state').value
        }));
      }

    });

    this.form.get('state').valueChanges.subscribe((val) => {
      if (val) {
        const yearVal: IYear = this.form.get('year').value;
        this.store.dispatch(FormFilterActions.UpdateStateAction({state: val}));
        this.store.dispatch(CountyActions.RetrieveCountiesAction({year: this.form.get('year').value, state: val}));
        this.store.dispatch(CommodityActions.RetrieveCommoditiesAction({year: yearVal.year, stateCode: val}));
      }
    });

    this.form.get('county').valueChanges.subscribe((val) => {
      this.store.dispatch(FormFilterActions.UpdateCountyAction(val));
    });

    this.form.get('commoditySelect').valueChanges.subscribe((val) => {
      this.store.dispatch(FormFilterActions.UpdateCommodityAction({commodity: val}));
    });
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.yearsSubscription.unsubscribe();
    this.stateSubscription.unsubscribe();
    this.countiesSubscription.unsubscribe();
  }

}
